import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import classnames from "classnames";

import "normalize.css";
import "./reset.css";
import "./index.css";

const HEADER_HEIGHT = "60px";
const SIDEBAR_WIDTH = "220px";
const SIDEBAR_BG_COLOR = "rgb(239, 244, 246)";

const Sidebar = ({ currentPath, pages }) => {
  return (
    <div
      className="Sidebar"
      style={{
        paddingTop: "70px",
        width: SIDEBAR_WIDTH,
        backgroundColor: SIDEBAR_BG_COLOR,
        height: "100%",
        zIndex: 10,
        position: "absolute",
        borderRight: "1px solid rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div
        className="Header-sidebar"
        style={{
          width: "100%",
          height: "60px",
          backgroundColor: SIDEBAR_BG_COLOR,
          display: "flex",
          alignItems: "center",
          padding: "5px 20px",
          fontWeight: "700",
          fontSize: "1.8rem",
          flexShrink: 0,
          position: "absolute",
          top: 0,
          left: 0,
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)"
        }}
      >
        <a href="https://vetspire.com">
          <span style={{ color: "rgb(40, 95, 127)" }}>Vetspire</span>&nbsp;API
        </a>
      </div>
      <div
        style={{
          flexGrow: "1",
          overflowY: "scroll",
          overflowX: "hidden"
        }}
      >
        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Guides</div>
          <Link to="/" className={currentPath === "/" && "active"}>
            Introduction
          </Link>
          <a target="_blank" href="http://graphql.org/learn/">
            GraphQL Guide
          </a>
        </div>

        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Queries</div>
          {pages
            .filter(
              node => node.type === "QUERY" && node.name.substr(0, 2) !== "__"
            )
            .sort((a, b) => a.name - b.name)
            .map(node => (
              <div key={node.path}>
                <Link
                  className={currentPath === node.path && "active"}
                  to={node.path}
                >
                  {node.name.slice(0, -7)}
                </Link>
                {node.fields.map(f => (
                  <Link
                    key={f.name}
                    className="sublink"
                    to={node.path + "#" + f.name}
                  >
                    {f.name}
                  </Link>
                ))}
              </div>
            ))}
        </div>

        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Mutations</div>
          {pages
            .filter(
              node =>
                node.type === "MUTATION" && node.name.substr(0, 2) !== "__"
            )
            .sort((a, b) => a.name - b.name)
            .map(node => (
              <div key={node.path}>
                <Link
                  className={currentPath === node.path && "active"}
                  to={node.path}
                >
                  {node.name.slice(0, -9)}
                </Link>
                {node.fields.map(f => (
                  <Link
                    key={f.name}
                    className="sublink"
                    to={node.path + "#" + f.name}
                  >
                    {f.name}
                  </Link>
                ))}
              </div>
            ))}
        </div>

        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Objects</div>
          {pages
            .filter(
              node =>
                node.type === "OBJECT" &&
                node.kind === "OBJECT" &&
                node.name.substr(0, 2) !== "__"
            )
            .sort((a, b) => a.name - b.name)
            .map(node => (
              <Link
                key={node.path}
                to={node.path}
                className={currentPath === node.path && "active"}
              >
                {node.name}
              </Link>
            ))}
        </div>

        {pages.filter(
          node =>
            node.type === "OBJECT" &&
            node.kind === "UNION" &&
            node.name.substr(0, 2) !== "__"
        ).length > 0 && (
          <div className="Sidebar-section">
            <div className="Sidebar-section-header">Unions</div>
            {pages
              .filter(
                node =>
                  node.type === "OBJECT" &&
                  node.kind === "UNION" &&
                  node.name.substr(0, 2) !== "__"
              )
              .sort((a, b) => a.name - b.name)
              .map(node => (
                <Link
                  key={node.path}
                  to={node.path}
                  className={currentPath === node.path && "active"}
                >
                  {node.name}
                </Link>
              ))}
          </div>
        )}

        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Input Objects</div>
          {pages
            .filter(
              node =>
                node.type === "OBJECT" &&
                node.kind === "INPUT_OBJECT" &&
                node.name.substr(0, 2) !== "__"
            )
            .sort((a, b) => a.name - b.name)
            .map(node => (
              <Link
                key={node.path}
                to={node.path}
                className={currentPath === node.path && "active"}
              >
                {node.name}
              </Link>
            ))}
        </div>

        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Enums</div>
          {pages
            .filter(
              node =>
                node.type === "OBJECT" &&
                node.kind === "ENUM" &&
                node.name.substr(0, 2) !== "__"
            )
            .sort((a, b) => a.name - b.name)
            .map(node => (
              <Link
                key={node.path}
                to={node.path}
                className={currentPath === node.path && "active"}
              >
                {node.name}
              </Link>
            ))}
        </div>

        <div className="Sidebar-section">
          <div className="Sidebar-section-header">Scalars</div>
          {pages
            .filter(
              node =>
                node.type === "OBJECT" &&
                node.kind === "SCALAR" &&
                node.name.substr(0, 2) !== "__"
            )
            .map(node => (
              <Link
                key={node.path}
                to={node.path}
                className={currentPath === node.path && "active"}
              >
                {node.name}
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

const Header = ({ currentPath }) => (
  <div
    className="Header"
    style={{
      width: "100%",
      height: HEADER_HEIGHT,
      position: "fixed",
      display: "flex",
      backgroundColor: "transparent"
    }}
  >
    <div
      className="Header-sidebar"
      style={{
        width: SIDEBAR_WIDTH,
        height: "100%",
        flexShrink: "0"
      }}
    />
    <section
      style={{
        flexGrow: 1
      }}
    >
      <div className="section-text" />
      <div
        className={classnames("section-example Header-example", {
          on: currentPath === "/"
        })}
      />
    </section>
  </div>
);

const query = `{
  Movie(title: "Inception") {
    releaseDate
    actors {
      name
    }
  }
}`;

const TemplateWrapper = ({ children, layoutContext: { pages }, history }) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Helmet>
        <title>Vetspire API Documentation</title>
        <meta charSet="utf-8" />
        <meta description="Vetspire API Documentation" />
        <link
          href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,700"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Source+Code+Pro"
          rel="stylesheet"
        />
      </Helmet>
      <div
        style={{
          width: "100%",
          height: "100%"
        }}
      >
        <Header currentPath={history.location.pathname} />
        <Sidebar pages={pages} currentPath={history.location.pathname} />
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            paddingLeft: SIDEBAR_WIDTH,
            paddingTop: HEADER_HEIGHT,
            width: "100%",
            height: "100%"
          }}
        >
          {children()}
        </div>
      </div>
    </div>
  );
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/templates/layout.js